import Counter from "./components/Counter";
import FetchData from "./components/FetchData";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import LocationsMap from "./components/location/LocationsMap";
import ProductList from "./components/ProductList";
import Menu from "./pages/Menu";
import Cart from "./components/cart/Cart";
import OrderStatus from "./components/order/OrderStatus";
import Checkout from "./components/cart/Checkout";
import Payment from "./components/cart/Payment";

const AppRoutes = [
    //{
    //    index: true,
    //    element: <Home />,
    //},
    {
        index: true,
        //path: "/locationsmap",
        element: <LocationsMap />,
    },
    {
        path: "/menu",
        element: <Menu />,
    },
    {
        path: "/order",
        element: <OrderStatus />,
    },
    {
        path: "/checkout",
        element: <Checkout />,
    },
    {
        path: "/payment",
        element: <Payment />,
    },
];

export default AppRoutes;
